import React from 'react';
import { Redirect } from 'react-router-dom';

const ReloadCatalogFormFill = props => {
  return <Redirect to={`/form/${props.match.params.category}`} />;
};

export default ReloadCatalogFormFill;
